import React, { useEffect, useRef, useState } from 'react'
import favicon from "../assets/favicon.png"
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginAPI, verifyMobileOTPAPI } from '../utils/api';
import loadingif from "../assets/loading-gif.gif";
import { Form } from 'react-bootstrap';
import { FaRegHandPointRight } from 'react-icons/fa';
import { FiArrowLeft, FiShield, FiSmartphone } from 'react-icons/fi';

const MobileOTP = () => {
    const [mobileotp, setMobileOTP] = useState({ center_otp: "" });
    const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
    const [resendTimer, setResendTimer] = useState(29);
    const mobile = localStorage.getItem("centermobile");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const otpRefs = useRef([]);

    useEffect(() => {
        if (!mobile || !/^[6-9][0-9]{9}$/.test(mobile)) {
            navigate('/');
            return undefined;
        }
        if (resendTimer <= 0) {
            return undefined;
        }

        const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
        return () => clearTimeout(timer);
    }, [resendTimer, mobile, navigate]);

    const maskedMobile = mobile ? `${mobile.slice(0, 3)}*****${mobile.slice(-4)}` : "**********";

    const handleOTPSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            setLoading(true);
            const mobiledata = {
                mobile,
                mobileotp: mobileotp.center_otp,
            };
            verifyMobileOTPAPI("tv-center-verify-mobile-otp", mobiledata).then((res) => {
                if (res.data.status === 1) {
                    localStorage.removeItem("tldata");
                    localStorage.setItem("centerdata", JSON.stringify(res.data.data || {}));
                    localStorage.removeItem("centermobile");
                    navigate("/center-tv");
                    toast.success(res.data.msg);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                    toast.error(res.data.msg);
                }
            }).catch(() => {
                setLoading(false);
                toast.error("OTP verification failed. Please try again.");
            })
        }
    }
    const resendMobileOTP = () => {
        if (resendTimer > 0) {
            return;
        }

        if (mobile && mobile.length === 10) {
            loginAPI("tv-center-send-mobile-otp", { center_mobile: mobile, login_type: "center" }).then((res) => {
                if (res.data.status === 1) {
                    setResendTimer(29);
                    toast.success("Mobile OTP has been sent.")
                }
                else {
                    toast.error(res.data.msg || "OTP could not be sent.")
                }
            }).catch(() => toast.error("OTP could not be sent."))
        }
        else {
            toast.error("Invalid Mobile Number!!");
        }
    }

    const updateOTPValue = (digits) => {
        const centerOtp = digits.join("");
        setOtpDigits(digits);
        setMobileOTP({ center_otp: centerOtp });
    };

    const handleOTPDigit = (event, index) => {
        const value = event.target.value.replace(/\D/g, "").slice(-1);
        const nextDigits = [...otpDigits];
        nextDigits[index] = value;
        updateOTPValue(nextDigits);

        if (value && index < otpRefs.current.length - 1) {
            otpRefs.current[index + 1]?.focus();
        }
    };

    const handleOTPKeyDown = (event, index) => {
        if (event.key === "Backspace" && !otpDigits[index] && index > 0) {
            otpRefs.current[index - 1]?.focus();
        }
    };

    return (
        <div className="homePage">
            <Helmet>
                <title>SATKARTAR:ADMIN::CENTER HEAD PANEL OTP</title>
            </Helmet>
            <div className="auth-shell">
                <div className="user_card otp_card">
                    <div className="auth-card-inner">
                        <div className="auth-header">
                            <div className="brand_logo_container">
                                <img src={favicon} className="brand_logo" alt="Satkartar logo" />
                            </div>
                            <h1 className="loginnames">VERIFY OTP</h1>
                            <p className="auth-subtitle">CENTER HEAD PANEL</p>
                            <span className="auth-pill"><FiSmartphone /> OTP sent to +91 {maskedMobile}</span>
                        </div>
                        <div className="form_container otp_form_container">
                            <Form noValidate validated={validated} onSubmit={handleOTPSubmit}>
                                <Form.Group controlId="validationCustom01" className="mobileinput otpinput">
                                    <Form.Label><FiShield /> ENTER 4-DIGIT OTP</Form.Label>
                                    <div className="otp-boxes">
                                        {otpDigits.map((digit, index) => (
                                            <Form.Control
                                                key={index}
                                                ref={(element) => {
                                                    otpRefs.current[index] = element;
                                                }}
                                                required
                                                type="text"
                                                inputMode="numeric"
                                                value={digit}
                                                onChange={(event) => handleOTPDigit(event, index)}
                                                onKeyDown={(event) => handleOTPKeyDown(event, index)}
                                                pattern="[0-9]"
                                                maxLength={1}
                                                minLength={1}
                                                className="otp-box"
                                                aria-label={`OTP digit ${index + 1}`}
                                            />
                                        ))}
                                    </div>
                                    <Form.Control
                                        className="otp-hidden-control"
                                        required
                                        type="text"
                                        value={mobileotp.center_otp}
                                        onChange={() => { }}
                                        pattern="[0-9]{4}"
                                        maxLength={4}
                                        minLength={4}
                                        name="center_otp"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        <FaRegHandPointRight /> Please provide a valid mobile OTP
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <button type="button" className="reSendMobileOTP" onClick={resendMobileOTP} disabled={resendTimer > 0}>
                                    {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
                                </button>
                                <div className="login_container">
                                    {loading ?
                                        <button disabled={true} type="submit" className="btn login_btn">
                                            <img src={loadingif} alt={loadingif} style={{ width: "7%", marginTop: "-3px" }} /> VERIFY OTP...
                                        </button>
                                        :
                                        <button type="submit" className="btn login_btn">VERIFY &amp; LOGIN</button>
                                    }
                                </div>
                                <button type="button" className="back-login" onClick={() => navigate("/")}>
                                    <FiArrowLeft /> Back to Login
                                </button>
                            </Form>
                        </div>
                        <p className="auth-footer">&copy; 2026 Sat kartar Life Limited.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileOTP
